import React from "react";
import "./Separator.scss";

interface SeparatorProps {
  className?: string;
}

export const Separator: React.FC<SeparatorProps> = ({ className = "" }) => {
  return <hr className={`separator ${className}`} />;
};
